<template>
 <div>

     <v-dialog v-model="dialog" persistent width="600">
         <v-card class="pa-4" height="400">
             <v-card-title class="text-h5 pl-6 font-weight-regular"><span>Download {{parameters?parameters.name:'File'}}</span></v-card-title>
             <v-card-text class="pb-0">
                 <!--{{parameters}}{{date}}-->
                     <v-row>
                         <v-col cols="12">
                             <v-radio-group class="mt-3 " row outlined dense v-model="range">
                             <v-radio label="Full Download" value="full"></v-radio>
                             <v-radio label="Specific Date Range" value="specific"></v-radio>
                             </v-radio-group>
                             <p v-show="range==='specific'" class="mb-1 mt-3">Select Date Range</p>
                             <date-range v-model="date" v-show="range==='specific'" auto-apply appendToBody opens="right">
                                 <template v-slot:input="picker" class="d-flex">
                                     <v-icon class="mr-3">mdi-calendar-blank</v-icon>
                                     <template>{{ picker.startDate | dateFormat }} - {{ picker.endDate | dateFormat }}</template>
                             </template>
                             </date-range>
                         </v-col>
                     </v-row>
             </v-card-text>
             <v-card-actions style="position: absolute; bottom: 10px;right: 20px;">
                 <v-spacer></v-spacer>
                 <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                 <v-btn class="primary px-3 text-capitalize" dark :loading="loading" @click="download">Download</v-btn>
             </v-card-actions>
         </v-card>
     </v-dialog>

 </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
    export default {
        name: "DownloadPopup",
        components: {},
        props: ['dialog', 'parameters'],
        data(){
            return{
                date: {startDate: moment(), endDate: moment()},
                range: 'full',
                loading: false
            }
        },
        methods:{
            download(){
                this.loading = true
                let data = {}
                if(this.range === 'specific'){
                    data = {customerId: this.parameters.customerId,
                            startDate: moment(this.date.startDate).format('DD-MM-YYYY'),
                            endDate: moment(this.date.endDate).format('DD-MM-YYYY')}
                }else{
                    data = {customerId: this.parameters.customerId}
                }
                this.directPrintPdf(this.parameters.url, data)
            },
            async directPrintPdf(url, data){
                let response = await axios({method:'POST', url: url, data:data, responseType: "blob"})
                this.loading = false
                 this.closeDialog()
                let iframe = document.createElement('iframe');
                document.body.appendChild(iframe);

                iframe.style.display = 'none';

                iframe.src = window.URL.createObjectURL(response.data)
                await new Promise (resolve => iframe.onload = () => {
                    iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe)
                    setTimeout(() => {
                        iframe.focus();
                        iframe.contentWindow.print();
                        resolve()
                    }, 1);
                });
            },
            closeDialog(){
                this.$emit('update:dialog', false)
            }
        }
    }
</script>

<style scoped>

</style>